import "./pozicioneVakante.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setPositions } from "../../Redux/Actions/pozicioneActions";

const API_URL = "https://api.arkiva.gov.al/api/open-positions";

const DOCUMENTS_URL = "https://arkiva.gov.al/Assets/Documents";

const PozicioneVakante = () => {
  const [loading, setLoading] = useState(false);
  const [positionsList, setPositionsList] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPositions = async () => {
      try {
        setLoading(true);

        const response = await axios.get(API_URL);

        const positions = Array.isArray(response.data.positions)
          ? [...response.data.positions].sort(
              (a, b) => new Date(b.announceDate) - new Date(a.announceDate),
            )
          : [];

        setPositionsList(positions);
        dispatch(setPositions(positions));
      } catch (error) {
        console.error("Error fetching positions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPositions();
  }, [dispatch]);

  const formatDate = (dateValue) => {
    if (!dateValue) {
      return "-";
    }

    const date = new Date(dateValue);

    if (Number.isNaN(date.getTime())) {
      return "-";
    }

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  };

  const getPositionUrl = (position) => {
    const link = position.link?.trim();

    if (link) {
      return link;
    }

    const file = position.file?.trim();

    if (file) {
      return `https://arkiva.gov.al/Assets/Documents/${encodeURIComponent(
        file,
      )}`;
    }

    return null;
  };

  return (
    <div className="pozicione-vakante-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="page-header">
        <div className="headerTitleLine"></div>
        <h1 className="page-title">Pozicione Vakante</h1>
      </div>

      <div className="page-content-karriera">
        {loading ? (
          <div className="positions-loading">
            Duke ngarkuar pozicionet vakante...
          </div>
        ) : (
          <div className="pozicione-table-wrapper">
            <table className="pozicione-table">
              <thead>
                <tr>
                  <th>Emërtimi i pozicionit</th>
                  <th>Data e shpalljes</th>
                  <th>Data e përfundimit</th>
                </tr>
              </thead>

              <tbody>
                {positionsList.length > 0 ? (
                  positionsList.map((position) => {
                    const positionUrl = getPositionUrl(position);

                    return (
                      <tr key={position._id}>
                        <td className="position-title-cell">
                          {positionUrl ? (
                            <a
                              href={positionUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="poz-link"
                            >
                              {position.title}
                            </a>
                          ) : (
                            <span className="position-title">
                              {position.title}
                            </span>
                          )}
                        </td>

                        <td className="poz-data">
                          {formatDate(position.announceDate)}
                        </td>

                        <td className="poz-data">
                          {formatDate(position.finalDate)}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="3" className="no-positions">
                      Nuk ka pozicione vakante të publikuara.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default PozicioneVakante;
